// extracted by mini-css-extract-plugin
export default {"avatar":"Avatar_avatar__0JZ8v","letter":"Avatar_letter__KFatC"};